import { WhatsappTemplateCategory } from "@jugl-web/rest-api";
import { NoParameters } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { InstagramAccountTab } from "./screens/InstagramAccountScreen/types";
import { WhatsappAccountTab } from "./screens/WhatsappAccountScreen/types";

export enum ManageAccountsDrawerTab {
  channels = "channels",
  aiAgentInsights = "aiAgentInsights",
}

export type ManageAccountsDrawerScreenToParametersMap = {
  connectedAccountList: NoParameters;
  aiAgentInsights: NoParameters;
  twilioAccount: NoParameters;
  instagramAccount: {
    tab?: InstagramAccountTab;
  };
  webChatBotAccount: NoParameters;
  whatsappAccount: {
    tab?: WhatsappAccountTab;
  };
  whatsappTemplateForm: {
    templateId?: string;
    templateCategory: WhatsappTemplateCategory;
  };
  liveChatAppAccount: NoParameters;
  emailAccount: NoParameters;
};

export type WhatsappBody = {
  body: string;
  variables: string[];
};
